// Deriva as iniciais (até 2 letras, maiúsculas) de um nome de usuário ou e-mail.
// Ex.: 'brennon.lima' -> 'BL'; 'brennon.lima@ampere.com.br' -> 'BL'; 'brennon' -> 'B'.
export default function getInitials(name?: string): string {
  if (!name) {
    return '';
  }

  const localPart = name.split('@')[0];
  const parts = localPart.split(/[.\-_\s]+/).filter(Boolean);

  return parts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}
